<script>
    import { fade, fly } from 'svelte/transition';
    export let overlayBg = 'rgba(57, 79, 93, 0.8)'
</script>

<style>
    .ModalOverlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 39;
    }
</style>

<div class="ModalOverlay" out:fade={{ duration: 200 }} style="background-color: {overlayBg};"> </div>